// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionsProductListStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductList";
import { css } from "styled-components";

requisitionsProductListStyles.linesWrapper = {
    css: css`
        margin-top: 0;
    `,
};
requisitionsProductListStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};

requisitionsProductListStyles.noResultsContainer = {
    css: css`
        text-align: left;
        padding: 20px;
        padding-left: 0px;
    `,
};

requisitionsProductListStyles.paginationWrapper = {
    css: css`
        margin-top: 16px;
    `,
};
requisitionsProductListStyles.selectAllCheckbox = {
    css: css`
        margin-bottom: 16px;
        margin-left: 20px;

    `,
};